import Text from '@/components/Text'
import { coreLayoutContainer, coreLayoutHeading } from '@/constants/measured-scope'
import { SeriesIndexInfoPageSection } from '@/shared/api-generated-types'

export interface Props extends Partial<SeriesIndexInfoPageSection> {}

const SeriesIndexBlock = ({ title }: Props): JSX.Element => {
  return (
    <header className={coreLayoutHeading}>
      <div className={coreLayoutContainer}>
        {title && (
          <Text
            className="fc-dark"
            tag="h2"
            weight="lg"
            responsiveSize={{
              sm: 'lg',
              lg: 'xl',
            }}
          >
            {title}
          </Text>
        )}
      </div>
    </header>
  )
}
export default SeriesIndexBlock
